import { type CSSProperties } from 'react';

import { createPortal } from 'react-dom';

import { JsmPlaygroundCursor } from './jsm-playground-cursor';

export const DEMO_CURSOR_TRAVEL_MS = 1050;
export const DEMO_CURSOR_FADE_MS = 400;

type JsmPlaygroundDemoCursorProps = {
	x: number;
	y: number;
	isVisible: boolean;
	isPressed: boolean;
	isTransitionEnabled: boolean;
	hasUserTakenOver: boolean;
	label: string;
	testId?: string;
	container?: HTMLElement | null;
};

export const JsmPlaygroundDemoCursor = ({
	x,
	y,
	isVisible,
	isPressed,
	isTransitionEnabled,
	hasUserTakenOver,
	label,
	testId = 'jsm-playground-demo-cursor',
	container,
}: JsmPlaygroundDemoCursorProps) => {
	const isShown = isVisible && !hasUserTakenOver;
	const cursor = (
		<JsmPlaygroundCursor
			variant="demo"
			dataVisible={isShown}
			isClicking={isPressed}
			label={label}
			testId={testId}
			style={
				{
					'--demo-cursor-opacity': isShown ? 1 : 0,
					'--demo-cursor-scale': isShown ? 1 : 0.92,
					'--demo-cursor-transition': isTransitionEnabled
						? `transform ${DEMO_CURSOR_TRAVEL_MS}ms cubic-bezier(0.33, 0, 0.2, 1)`
						: 'transform 0ms',
					'--demo-cursor-fade': `${DEMO_CURSOR_FADE_MS}ms`,
					'--demo-cursor-x': `${x}px`,
					'--demo-cursor-y': `${y}px`,
				} as CSSProperties
			}
		/>
	);

	return container ? createPortal(cursor, container) : cursor;
};
